import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
    FaIdCard, 
    FaAddressBook, 
    FaImage, 
    FaSignature, 
    FaChartBar, 
    FaCog 
} from 'react-icons/fa'; // 🎯 Added clean icons for your side navigation links
import './SideMenu.css';

const SideMenu = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <button className="menu-toggle" onClick={toggleMenu}>
                ☰
            </button>
            <aside className={`side-menu ${isOpen ? 'show' : 'hidden'}`}>
                <nav>
                    <ul>
                        <li>
                            <Link to="/cards">
                                <FaIdCard className="menu-icon" /> Cards
                            </Link>
                        </li>
                        <li>
                            <Link to="/contacts">
                                <FaAddressBook className="menu-icon" /> Contacts
                            </Link>
                        </li>
                        <li>
                            <Link to="/backgrounds">
                                <FaImage className="menu-icon" /> Backgrounds
                            </Link>
                        </li>
                        <li>
                            <Link to="/emailsignatures">
                                <FaSignature className="menu-icon" /> Email Signatures
                            </Link>
                        </li>
                        <li>
                            <Link to="/analytics">
                                <FaChartBar className="menu-icon" /> Analytics
                            </Link>
                        </li>
                        <li>
                            <Link to="/settings">
                                <FaCog className="menu-icon" /> Settings
                            </Link>
                        </li>
                    </ul>
                </nav>
            </aside>
        </>
    );
}

export default SideMenu;